var React = require('react');

function Tt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#e00000","fillRule":"evenodd","d":"M463.7 480L0 1v478.8l463.7.2zM176.3 0L640 479V.2L176.3 0z","key":1}),React.createElement("path",{"fillRule":"evenodd","d":"M27.7.2h118.6l468.2 479.3H492.2L27.7.2z","key":2})]);
}

Tt.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Tt;

Tt.default = Tt;
